import { createContext, useContext } from 'react';

/**
 * Client-side provider for resolved Vercel Flag values.
 *
 * Mounted once in `pages/_app.js` and seeded from
 * `pageProps.appData._vercelFlags`, which is populated in
 * `helpers/initializePage.js` by parsing `x-vf-*` request headers set by
 * middleware.
 *
 * Companion server-side reader for `getServerSideProps` is `./getFlag`.
 */

const VercelFlagsContext = createContext({});

const VercelFlagsProvider = ({ children, flags }) => (
  <VercelFlagsContext.Provider value={flags || {}}>
    {children}
  </VercelFlagsContext.Provider>
);

/**
 * Read a Vercel flag value in a client component.
 *
 * @param {string} flagName - Vercel flag key (e.g. `getapp-ai-assistant`)
 * @param {number} [fallback=0] - Value when the flag is not present in context
 * @returns {number}
 */
export const useFlag = (flagName, fallback = 0) => {
  const allFlags = useContext(VercelFlagsContext);
  return allFlags?.[flagName] ?? fallback;
};

export default VercelFlagsProvider;
